import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles((theme) => ({
  lessonTitleContainer: {
    display: 'flex',
    alignContent: 'start',
    alignItems: 'start',
    width: '100%',
    marginBottom: '1.5rem'
  },
  title: {
    fontSize: '1.75rem',
    [theme.breakpoints.up('md')]: {
      fontSize: '2.25rem'
    }
  }
}));
